<div class="account-menu">
    <div *ngIf="user">
        <a routerLink="/account/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
            <!-- <div class="account-menu__user-avatar">
                <img src="assets/images/avatars/avatar-3.jpg" alt="">
            </div> -->
            <div class="account-menu__user-info">
                <div class="account-menu__user-name">{{user.name}}</div>
                <div class="account-menu__user-email">{{user.email}}</div>
            </div>
        </a>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="/account/profile" (click)="closeMenu.emit()">{{"edit_profile"|translate}}</a></li>
            <li><a routerLink="/account/subscription" (click)="closeMenu.emit()">{{"subscription"|translate}}</a></li>
            <li><a routerLink="/account/orders" (click)="closeMenu.emit()">{{"order_history"|translate}}</a></li>
            <li><a routerLink="/compare" (click)="closeMenu.emit()">{{"compare"|translate}}</a></li>
            <li *ngIf="siteService.features?.quotations"><a routerLink="/account/quotation-drafts" (click)="closeMenu.emit()">{{"quotation_history"|translate}}</a></li>
            <li *ngIf="siteService.features?.quotationRequests"><a routerLink="/rfq/request" (click)="closeMenu.emit()">{{"quotation_history"|translate}}</a></li>
            <li><a routerLink="/account/messages" (click)="closeMenu.emit()">{{"messages"|translate}}</a></li>
            <li *ngIf="siteService.features?.chat"><a routerLink="/account/live-chat" (click)="closeMenu.emit()">{{"live_chat"|translate}}</a></li>
            <li><a routerLink="/account/addresses" (click)="closeMenu.emit()">{{"addresses"|translate}}</a></li>
            <li><a routerLink="/account/password" (click)="closeMenu.emit()">{{"password"|translate}}</a></li>
        </ul>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="" (click)="logout()" class="logout-button" style="color: #dc3545;">{{"logout"|translate}}</a></li>
        </ul>
    </div>
</div>
